import { Rating } from "primereact/rating";

import { PropsWithClassName } from "../../common/types/PropsWithClassName";

interface FeedbackAnswerRatingProps extends PropsWithClassName {
  readOnly?: boolean;
  size?: "small" | "large";
  stars?: number;
  value?: number;
  onChange?: (value: number) => void;
}

export default function FeedbackAnswerRating({ className, readOnly, size, stars = 5, value, onChange }: FeedbackAnswerRatingProps) {
  const isSmall = size === "small";
  const getIconsSize = () => (isSmall ? "text-sm" : "text-lg");

  return (
    <Rating
      className={`${className}`}
      onIcon={<i className={`${getIconsSize()} pi pi-star-fill text-yellow-400`} />}
      offIcon={<i className={`${getIconsSize()} pi pi-star`} />}
      readOnly={readOnly}
      cancel={false}
      stars={stars}
      value={value}
      onChange={(e) => onChange?.(e.value!)}
    />
  );
}
